import React from 'react';

import { Wrapper } from './TranscriptEmbed.styled';
import Video, { VideoProps } from 'Components/Video';
import Table from 'Components/Table';

export interface Props {
    transcriptEmbed: VideoProps;
}

const TranscriptEmbed: React.FC<Props> = ({ transcriptEmbed }) => {
    return (
        <Wrapper>
            <Video {...transcriptEmbed} transcript={undefined} />
            {transcriptEmbed.transcript && transcriptEmbed.transcript.tableRows.length >= 1 && (
                <Table {...transcriptEmbed.transcript} />
            )}
        </Wrapper>
    );
};

export default TranscriptEmbed;
